<template>
    <div>
        <!-- Company Mismatch Warning -->
        <div v-if="showCompanyMismatchWarning" class="text-center mt-12">
            <p class="error--text" style="font-size: 1.1rem;" v-html="$t('lang_GENERIC_CONTRACTS_MESSAGE_WARNING_CONTRACT_BELONGS_TO_OTHER_COMPANY', [contractDetails.contractName, contractDetails.alvId, contractDetails.contractType, contractDetails.connectedCompanyName]).replace(/\\n/g, '<br>')"></p>
        </div>
        <!-- Normal Edit Form -->
        <BaseEditPage v-else
            :context="context"
            :alvqa="alvqa"
            cancelIconRoute="/contracts/publishing"
            :openMultiplePanels="false"
        >
<!-- HEADLINE -->
        <template v-slot:headline="{ data }">
            <div :alvqa="alvqa + '-title'">
                {{ data.contractName ? data.contractName : $t('lang_GENERAL_CAPTION_EDIT_PAGE_UNTITLED') }}
            </div>
        </template>

<!-- EDIT FORM -->
        <template v-slot:editForm>
            <!-- 1st col -->
            <!-- <v-col cols="2">
                <v-row>
                    <v-col>
                        <v-img
                            aspect-ratio="1"
                            class="defaultImageEditPage"
                            :alvqa="alvqa + '-image'"
                        >
                            <v-row
                                class="fill-height ma-0"
                                align="center"
                                justify="center"
                            >
                                <BaseIcon 
                                    @click="uploadCover()"
                                    icon="cloud_upload"
                                    tooltipText="lang_GENERAL_BUTTON_UPLOAD_FILE"
                                />
                            </v-row>
                        </v-img>
                    </v-col>
                </v-row>
            </v-col> -->
            
            <!-- 1st column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField
                        :context="context"
                        field="ContractName"
                        :label="$t('lang_GENERIC_CONTRACTS_CONTRACT_TITLE')" 
                        :alvqa="alvqa + '-textfield-contract-name'"
                        rules="required"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="ContractType"
                        :items="contractType" 
                        :clearable="false"
                        :additionalFunction="switchToSLG"
                        rules="required"
                        :label="$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_TYPE')" 
                        :alvqa="alvqa + '-dropdown-contract-type'"
                    />
                </v-row> 
                <v-row>
                    <BaseEditPageAutocomplete 
                        :context="context"
                        field="Licensor"
                        :label="$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACTING_PARTY')"
                        rules="required"
                        :withFreeText="false"
                        :alvqa="alvqa + '-autocomplete-licensor-textfield'"
                    >
                        <template v-slot:selection="{ item }">
                            <div class="ellipsis" :alvqa="alvqa + '-autocomplete-licensor-selection'">
                                <!-- {{ item.gemaName }}
                                <span v-if="$alvPlugin.printName(item)">
                                    ({{ item.firstName }} {{ item.lastName }})
                                </span> -->
                                {{ $alvPlugin.showNameOfAzEntry(item) }}
                            </div>
                        </template>
                        <template v-slot:items="{ items }">
                            <v-list-item-content :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId">
                                <v-list-item-title :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId + '-title'">
                                    <!-- {{ items.gemaName }}
                                    {{ $alvPlugin.printName(items) ? '(' + items.firstName + ' ' + items.lastName +')' : ''}} -->
                                    {{ $alvPlugin.showNameOfAzEntry(items) }}
                                    <!--  
                                        typeOfAz:
                                            allowed values: P, D or G
                                            P => Person => P in circle
                                            D => Distributor => D in circle (in german V for 'Vertrieb')
                                            G => Group => G in circle
                                        -->
                                        <v-avatar color="grey" size="20" class="caption">{{ items.typeOfAz }}</v-avatar>
                                        <!-- TODO: check i18n {{ i18n.locale === 'de' && items.item.typeOfAz === 'D' ? 'V' : items.item.typeOfAz }} -->
                                </v-list-item-title>
                                <v-list-item-subtitle :alvqa="alvqa + '-autocomplete-licensor-dropdown-' + items.alvId + '-subtitle'">
                                    {{ $t('lang_IPI') }}: {{ items.ipi !== '' ? items.ipi : $t('lang_GENERIC_CAPTION_NONE') }} | {{ items.alvId }}
                                </v-list-item-subtitle>
                            </v-list-item-content>
                        </template>
                    </BaseEditPageAutocomplete>
                </v-row>
                <v-row class="align-center">
                    <v-col class="py-0 pl-4 pr-0">
                        <BaseEditPageAutocomplete
                            v-if="!showBulkInclude"
                            :context="context"
                            field="Include"
                            :label="$t('lang_PUBLISHING_WORKS_EXPORT_INCLUDE_TERRITORY')"
                            :withFreeText="false"
                            :withMargin="false"
                            :multiple="true"
                            :returnObject="false"
                            :alvqa="alvqa + '-territories-include'"
                        >
                            <template v-slot:selection></template>
                            <template v-slot:items="{ items }">
                                <v-list-item-content>
                                    <v-list-item-title>{{ territoryOptionLabel(items) }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </BaseEditPageAutocomplete>
                        <v-text-field
                            v-else
                            v-model="bulkIncludeText"
                            :label="$t('lang_GENERIC_CAPTION_REGION_INCLUDE_BULK')"
                            :placeholder="$t('lang_GENERIC_CAPTION_REGION_BULK_PLACEHOLDER')"
                            :alvqa="alvqa + '-bulk-include-input'"
                            @keyup.enter.prevent="applyBulkTerritory('include')"
                        >
                            <template v-slot:append>
                                <v-btn
                                    icon
                                    small
                                    type="button"
                                    color="primary"
                                    :disabled="!bulkIncludeText || bulkIncludeText.trim() === ''"
                                    :alvqa="alvqa + '-bulk-include-add-btn'"
                                    @click="applyBulkTerritory('include')"
                                >+</v-btn>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="auto" class="py-0 pl-0 pr-2 d-flex align-center">
                        <BaseIcon
                            icon="content_paste"
                            small
                            :alvqa="alvqa + '-toggle-bulk-include-paste-icon'"
                            @click="toggleBulkTerritory('include')"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="includedTerritories.length" class="mt-1 mb-4">
                    <div class="ml-4 mr-4">
                        <v-chip
                            v-for="code in includedTerritories"
                            :key="'include-' + territoryCode(code)"
                            color="iconStandard"
                            text-color="white"
                            close
                            class="mr-2 mb-1"
                            @click:close="removeTerritory('include', code)"
                        >
                            {{ territoryLabel(code) }}
                        </v-chip>
                    </div>
                </v-row>
                <v-row class="align-center">
                    <v-col class="py-0 pl-4 pr-0">
                        <BaseEditPageAutocomplete
                            v-if="!showBulkExclude"
                            :context="context"
                            field="Exclude"
                            :label="$t('lang_PUBLISHING_WORKS_EXPORT_EXCLUDE_TERRITORY')"
                            :withFreeText="false"
                            :withMargin="false"
                            :multiple="true"
                            :returnObject="false"
                            :alvqa="alvqa + '-territories-exclude'"
                        >
                            <template v-slot:selection></template>
                            <template v-slot:items="{ items }">
                                <v-list-item-content>
                                    <v-list-item-title>{{ territoryOptionLabel(items) }}</v-list-item-title>
                                </v-list-item-content>
                            </template>
                        </BaseEditPageAutocomplete>
                        <v-text-field
                            v-else
                            v-model="bulkExcludeText"
                            :label="$t('lang_GENERIC_CAPTION_REGION_EXCLUDE_BULK')"
                            :placeholder="$t('lang_GENERIC_CAPTION_REGION_BULK_PLACEHOLDER')"
                            :alvqa="alvqa + '-bulk-exclude-input'"
                            @keyup.enter.prevent="applyBulkTerritory('exclude')"
                        >
                            <template v-slot:append>
                                <v-btn
                                    icon
                                    small
                                    type="button"
                                    color="primary"
                                    :disabled="!bulkExcludeText || bulkExcludeText.trim() === ''"
                                    :alvqa="alvqa + '-bulk-exclude-add-btn'"
                                    @click="applyBulkTerritory('exclude')"
                                >+</v-btn>
                            </template>
                        </v-text-field>
                    </v-col>
                    <v-col cols="auto" class="py-0 pl-0 pr-2 d-flex align-center">
                        <BaseIcon
                            icon="content_paste"
                            small
                            :alvqa="alvqa + '-toggle-bulk-exclude-paste-icon'"
                            @click="toggleBulkTerritory('exclude')"
                        />
                    </v-col>
                </v-row>
                <v-row v-if="excludedTerritories.length" class="mt-1 mb-4">
                    <div class="ml-4 mr-4">
                        <v-chip
                            v-for="code in excludedTerritories"
                            :key="'exclude-' + territoryCode(code)"
                            color="iconStandard"
                            text-color="white"
                            close
                            class="mr-2 mb-1"
                            @click:close="removeTerritory('exclude', code)"
                        >
                            {{ territoryLabel(code) }}
                        </v-chip>
                    </div>
                </v-row>
                <v-row>
                    <BaseEditPageTextarea 
                        :context="context"
                        field="Notes"
                        rows="3"
                        :label="$t('lang_GENERAL_CAPTION_NOTES')"
                        :alvqa="alvqa + '-textarea-notes'"
                    />
                </v-row>
            </v-col>
            
            <!-- 2nd column -->
            <v-col cols="3">
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="AlvId"
                        :label="$t('lang_CAPTION_ALVID')"
                        :alvqa="alvqa + '-textfield-alvid'"
                        :clearable="false"
                        :readonly="true"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField
                        :context="context"
                        field="GemaAgreementNo"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_SOCIETY_AGREEMENT_NUMBER')"
                        :iconTooltipText="$t('lang_CONTRACTS_PUBLISHING_TOOLTIP_SOCIETY_AGREEMENT_NUMBER')"
                        :alvqa="alvqa + '-textfield-gema-agreement-number'"
                        :disabled="true"
                        :readonly="true"
                        :clearable="false"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="GemaScheduleNo"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_SOCIETY_SCHEDULE_NUMBER')"
                        :iconTooltipText="$t('lang_CONTRACTS_PUBLISHING_TOOLTIP_SOCIETY_SCHEDULE_NUMBER')"
                        :alvqa="alvqa + '-textfield-gema-schedule-number'"
                    />
                </v-row>
                <v-row>
                    <!-- IDEA: rule for only numbers? -->
                    <BaseEditPageTextField
                        :context="context"
                        field="InitialBalance"
                        rules='positiveOrNegativeWithMaxTwoDigits'
                        :label="initialBalanceLabel"
                        :alvqa="alvqa + '-textfield-initial-balance'"
                    />
                </v-row>
                <v-row class="ml-1 mr-1">
                    <BasePeriod    
                        :context="context" 
                        widthYearField="4"
                        widthTimeUnitField="5"
                        widthNumberField="3"
                        :clearable="true"
                        periodLabel="lang_CONTRACTS_LABEL_CAPTION_INITIAL_BALANCE_PERIOD"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="Tags"
                        :label="$t('lang_GENERIC_CAPTION_TAGS')"
                        :iconTooltipText="$t('lang_GENERAL_INFO_MESSAGE_WHITE_SPACE_SEPARATED')"
                        :alvqa="alvqa + '-textfield-tags'"
                    />
                </v-row>
            </v-col>

            <!-- 3rd column -->
            <v-col>
                <v-row> 
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ContractDate"
                        :label="$t('lang_GENERIC_CONTRACTS_CAPTION_CONTRACT_DATE')"
                        :alvqa="alvqa + '-datepicker-contract-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ValidFromDate"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_VALID_FROM')"
                        :alvqa="alvqa + '-datepicker-valid-from-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ValidUntilDate"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_VALID_UNTIL')"
                        :alvqa="alvqa + '-datepicker-valid-until-date'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="GemaContractType"
                        :items="gemaContractTypes" 
                        :rules="isSLG ? 'required' : {}"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_GEMA_CONTRACT_TYPE')" 
                        :alvqa="alvqa + '-dropdown-gema-contract-type'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDatePicker 
                        :context="context"
                        field="ReminderDate"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_REMINDER_DATE')"
                        :alvqa="alvqa + '-datepicker-reminder-date'"
                    />
                </v-row>
                <v-row>
                    <!-- tooltip does not work for dropdowns, just preparatory -->
                    <BaseEditPageDropdown 
                        :context="context"
                        field="Refunding"
                        :items="refundingOptions" 
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_REFUNDING')" 
                        :iconTooltipText="$t('lang_CONTRACTS_PUBLISHING_TOOLTIP_REFUNDING_BY')"
                        :alvqa="alvqa + '-dropdown-refunding'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="SpTresholdPr"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_SP_TRESHOLD_PR')"
                        :iconTooltipText="$t('lang_GENERIC_TOOLTIP_NDA_PARTNER_ONLY')"
                        suffix="%"
                        :alvqa="alvqa + '-textfield-sp-treshold-pr'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="SpTresholdMr"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_SP_TRESHOLD_MR')"
                        :iconTooltipText="$t('lang_GENERIC_TOOLTIP_NDA_PARTNER_ONLY')"
                        suffix="%"
                        :alvqa="alvqa + '-textfield-sp-treshold-mr'"
                    />
                </v-row>
                
            </v-col>

            <!-- 4th column -->
            <v-col>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="NumberOfAssignedWorksContract"
                        :label="$t('lang_GENERIC_CAPTION_NUMBER_OF_WORKS') +  ' ' + $t('lang_CONTRACTS_PUBLISHING_CAPTION_MAIN_CATALOGUE')"
                        :disabled="true"
                        :clearable="false"
                        :alvqa="alvqa + '-textfield-number-of-assigned-works-contract'"
                        :readonly="true"
                        :formatAsInteger="true"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageTextField 
                        :context="context"
                        field="NumberOfAssignedWorksSubCatalogue"
                        :label="$t('lang_GENERIC_CAPTION_NUMBER_OF_WORKS') +  ' ' + $t('lang_CONTRACTS_PUBLISHING_CAPTION_SUB_CATALOGUE')"
                        :disabled="true"
                        :clearable="false"
                        :alvqa="alvqa + '-textfield-number-of-assigned-works-sub-catalogues'"
                        :readonly="true"
                        :formatAsInteger="true"
                    />
                </v-row>
                <v-row>
                    <!-- lang const! -->
                    <BaseEditPageTextField 
                        :context="context"
                        field="ArColl"
                        :label="$t('lang_GENERIC_CAPTION_COLL_PERCENT_PR')" 
                        :iconTooltipText="$t('lang_CONTRACTS_PUBLISHING_TOOLTIP_COLL_SHARE_PR')"
                        suffix="%"
                        :rules="isSLG ? 'required' : {}"
                        :disabled="!isSLG"
                        :alvqa="alvqa + '-textfield-ar-coll'"
                    />
                </v-row>
                <v-row>
                    <!-- lang const! -->
                    <BaseEditPageTextField 
                        :context="context"
                        field="MrColl"
                        :label="$t('lang_GENERIC_CAPTION_COLL_PERCENT_MR')" 
                        :iconTooltipText="$t('lang_CONTRACTS_PUBLISHING_TOOLTIP_COLL_SHARE_MR')"
                        suffix="%"
                        :rules="isSLG ? 'required' : {}"
                        :disabled="!isSLG"
                        :alvqa="alvqa + '-textfield-mr-coll'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="ShareFrom"
                        :items="shareFrom" 
                        :rules="isSLG ? 'required' : {}"
                        :disabled="!isSLG"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_COLL_SHARE_MR_FROM')" 
                        :alvqa="alvqa + '-dropdown-share-from'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SvdForSpw"
                        :items="yesNoItems" 
                        :iconTooltipText="$t('lang_CONTRACTS_PUBLISHING_TOOLTIP_SVD_FOR_SPW')"
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_SVD_FOR_SPW')" 
                        :alvqa="alvqa + '-dropdown-svd-for-spw'"
                    />
                </v-row>
                <v-row>
                    <BaseEditPageDropdown 
                        :context="context"
                        field="SourceAdaption"
                        :items="sourceAdaption" 
                        :label="$t('lang_CONTRACTS_PUBLISHING_CAPTION_SOURCE_ADAPTION')" 
                        :iconTooltipText="$t('lang_GENERIC_TOOLTIP_NDA_PARTNER_ONLY')"
                        :alvqa="alvqa + '-dropdown-source-adaption'"
                    />
                </v-row>
            </v-col>
        </template>

        <template v-slot:panels>
            <DeletionDialog :useContextSetinVuex="true" />
            <ContextHelpDialog />

            <!-- SPLITS PANEL COMPONENTS (hidden, not removed) -->
            <PublishingContractsSplitsEditPanel v-if="false" />  
            <PublishingContractsSplitsEditPanelDialog v-if="false" />

            <!-- WORKS, CONDITIONS, ADVANCE, COSTS, SUB-CATALOGUES (not applicable to PVE payee-only agreement) -->
            <template v-if="!isPVE">
            <PublishingContractsWorkEditPanel />
            <PublishingContractsWorksEditPanelDialog />
            <PublishingContractsWorksEditPanelSetTypeDialog />

            <!-- CONDITIONS -->
            <PublishingContractsConditionsEditPanel />
            <PublishingContractsConditionsEditDialog />
            <PublishingContractsSplitEditDialog />

            <!-- ADVANCE -->
            <PublishingContractsAdvanceEditPanel />
            <PublishingContractsAdvanceEditPanelDialog />

            <!-- COSTS -->
            <PublishingContractsCostsEditPanel />
            <PublishingContractsCostsEditPanelDialog />
            
            <!-- AGREEMENT NUMBERS (above the sub-catalogue panels it refers to) -->
            <PublishingContractsAgreementNumbersEditPanel />
            <PublishingContractsAgreementNumbersEditPanelDialog />

            <!-- Sub-Catalogue Panels -->
            <PublishingContractsSubCataloguesEditPanel 
                v-for="(subcatalogue, index) in subcatalogues"
                :key="index"
                :subcatalogue="subcatalogue"
            />
            <PublishingContractsSubCataloguesWorksEditPanelDialog />
            </template>

            <!-- MEDIA -->
            <PublishingContractsMediaEditPanel />
            <MediaFileUploadDialog 
                acceptedFiles='.png,.jpg,.jpeg,.pdf,.txt,.wav,.mp3,.flac,.zip'
                placeholder="lang_GENERIC_CAPTION_SELECT_FILES_FOR_UPLOAD"
                headline="lang_GENERAL_FILE_IMPORT_DIALOG_TITLE_UPLOAD_FILE" 
                :context="context + 'Media'"
                detailsCall="getPublishingContractsDetails"
                directory="contracts/publishing/"
            />
        </template>
    </BaseEditPage>
    </div>
</template>

<script>
import BaseEditPage from '@/components/_base/BaseEditPage'
import BaseEditPageTextField from '@/components/_editForm/BaseEditPageTextField'
import BaseEditPageTextarea from '@/components/_editForm/BaseEditPageTextarea'
import BaseEditPageDropdown from '@/components/_editForm/BaseEditPageDropdown'
import BaseEditPageDatePicker from '@/components/_editForm/BaseEditPageDatePicker'
import BaseEditPageAutocomplete from '@/components/_editForm/BaseEditPageAutocomplete'
import BasePeriod from '@/components/_base/BasePeriod'
import BaseIcon from '@/components/_buttons/BaseIcon'
import { parseBulkCountryString, splitTerritoryCodes } from '@/utils/territoryBulkPaste'
import MediaFileUploadDialog from '@/components/_dialogs/MediaFileUploadDialog'

import PublishingContractsSplitsEditPanel from './_panels/1_splits/PublishingContractsSplitsEditPanel'
import PublishingContractsWorkEditPanel from './_panels/2_works/PublishingContractsWorksEditPanel.vue'
import PublishingContractsWorksEditPanelSetTypeDialog from './_panels/2_works/PublishingContractsWorksEditPanelSetTypeDialog'

import PublishingContractsSubCataloguesEditPanel from './_panels/3_subcatalogues/PublishingContractsSubCataloguesEditPanel'
import PublishingContractsConditionsEditPanel from './_panels/4_conditions/PublishingContractsConditionsEditPanel'
import PublishingContractsSplitEditDialog from './_panels/4_conditions/PublishingContractsSplitEditDialog'


import PublishingContractsWorksEditPanelDialog from './_panels/2_works/PublishingContractsWorksEditPanelDialog.vue'
import PublishingContractsSplitsEditPanelDialog from './_panels/1_splits/PublishingContractsSplitsEditPanelDialog'
import PublishingContractsSubCataloguesWorksEditPanelDialog from './_panels/3_subcatalogues/PublishingContractsSubCataloguesWorksEditPanelDialog'
import PublishingContractsConditionsEditDialog from './_panels/4_conditions/PublishingContractsConditionsEditDialog'
import DeletionDialog from '@/components/_dialogs/DeletionDialog'
import ContextHelpDialog from '@/components/_dialogs/ContextHelpDialog'

import {    
        DropdownGenericYesNo,
} from '@/assets/dropdowns/alvDropdowns.js'
import PublishingContractsMediaEditPanel from './_panels/5_media/PublishingContractsMediaEditPanel.vue'
import PublishingContractsAdvanceEditPanel from './_panels/6_advance/PublishingContractsAdvanceEditPanel.vue'
import PublishingContractsAdvanceEditPanelDialog from './_panels/6_advance/PublishingContractsAdvanceEditPanelDialog.vue'
import PublishingContractsCostsEditPanel from './_panels/7_costs/PublishingContractsCostsEditPanel.vue'
import PublishingContractsCostsEditPanelDialog from './_panels/7_costs/PublishingContractsCostsEditPanelDialog.vue'
import PublishingContractsAgreementNumbersEditPanel from './_panels/8_agreement-numbers/PublishingContractsAgreementNumbersEditPanel.vue'
import PublishingContractsAgreementNumbersEditPanelDialog from './_panels/8_agreement-numbers/PublishingContractsAgreementNumbersEditPanelDialog.vue'

export default {
    name: "PublishingContractsEdit",
    components: {        
        BaseEditPage,
        BaseEditPageTextField,
        BaseEditPageTextarea,
        BaseEditPageDropdown,
        BaseEditPageDatePicker,
        BaseEditPageAutocomplete,
        BasePeriod,
        BaseIcon,

        DeletionDialog,
        ContextHelpDialog,
        PublishingContractsWorksEditPanelDialog,
        PublishingContractsSplitsEditPanelDialog,
        PublishingContractsSubCataloguesWorksEditPanelDialog,
        PublishingContractsWorksEditPanelSetTypeDialog,
        PublishingContractsConditionsEditDialog,

        PublishingContractsSplitsEditPanel,
        PublishingContractsWorkEditPanel,
        PublishingContractsSubCataloguesEditPanel,
        PublishingContractsConditionsEditPanel,
        PublishingContractsSplitEditDialog,
        PublishingContractsMediaEditPanel,
        PublishingContractsAdvanceEditPanel,
        PublishingContractsAdvanceEditPanelDialog,
        PublishingContractsCostsEditPanel,
        PublishingContractsCostsEditPanelDialog,
        PublishingContractsAgreementNumbersEditPanel,
        PublishingContractsAgreementNumbersEditPanelDialog,
        MediaFileUploadDialog
    },    
    data() {
        return {   
            context: "PublishingContracts",
            alvqa: "contracts-publishing-edit-form",
            bulkIncludeText: '',
            bulkExcludeText: '',
            showBulkInclude: false,
            showBulkExclude: false,
        }
    },
    computed: {
        includedTerritories() {
            return this.$store.getters.getPublishingContractsDetailsInclude || []
        },
        excludedTerritories() {
            return this.$store.getters.getPublishingContractsDetailsExclude || []
        },
        contractDetails() { 
            return this.$store.getters.getPublishingContractsDetails 
        },
        selectedPublishingCompanyAlvId() {
            const companyData = this.$store.getters.getSelectedPublishingCompanyId
            if (!companyData) return null
            // Handle both object (after company change via dropdown) and number (from localStorage)
            const id = typeof companyData === 'object' ? companyData.id : companyData
            return 'ALV' + String(id).padStart(9, '0') + 'PC'
        },
        showCompanyMismatchWarning() {
            const details = this.contractDetails
            if (!details || !details.connectedCompanyAlvId) return false
            // Only check if loaded details belong to the current route (avoid stale data)
            if (details.alvId !== this.$route.params.alvId) return false
            return details.connectedCompanyAlvId !== this.selectedPublishingCompanyAlvId
        },
        gemaContractTypes() {
            return [
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_OPTION_GENERAL_CONTRACT'), 
                    value: 'general',
                    alvqa: this.alvqa + '-dropdown-contract-type-general'
                }, 
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_OPTION_INDIVIDUAL_CONTRACT'), 
                    value: 'individual',
                    alvqa: this.alvqa + '-dropdown-contract-type-individual'
                }
            ]
        },
        refundingOptions() {
            return [
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_OPTION_BY_PWR'), 
                    value: 'pwr',
                    alvqa: this.alvqa + '-dropdown-refunding-pwr'
                }, 
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_OPTION_BY_CONTRACTS'), 
                    value: 'contract',
                    alvqa: this.alvqa + '-dropdown-refunding-contract'
                }, 
            ]
        },
        shareFrom() {
            return [
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_OPTION_OF_TOTAL_SHARES'), 
                    value: 'totalShare',
                    alvqa: this.alvqa + '-dropdown-share-from-total-share'
                },  
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_OPTION_OF_PUBLISHERS_SHARE'), 
                    value: 'publisherShare',
                    alvqa: this.alvqa + '-dropdown-share-from-publisher-share'
                } 
            ]
        },
        sourceAdaption() {
            return [
                {
                    text: this.$t('lang_CONTRACTS_PUBLISHING_OPTION_ADAPTIVE_BASE'), 
                    value: 'adaptiveBase',
                    alvqa: this.alvqa + '-dropdown-source_adaption-adaptive-base'
                }                
            ]
        },
        contractType() {
            let alvqa = this.alvqa + "-dropdown-contract-type-"
            let typesArr
            let types = this.$store.getters.getPublishingContractsTypes

            if(types !== undefined) {
                typesArr = JSON.parse(JSON.stringify(types))
                typesArr.forEach(type => {
                    type['alvqa'] = alvqa + type.value.toLowerCase()
                });
            }
            return typesArr
        },
        subcatalogues() { return this.$store.getters.getPublishingContractsSubCatalogues },
        yesNoItems() { return DropdownGenericYesNo },
        initialBalanceLabel() { return this.$t('lang_CONTRACTS_LABEL_CAPTION_INITIAL_BALANCE') },
        isSLG() {
            if (this.$store.getters.getPublishingContractsDetailsContractType == "SLG") 
                return true
            else
                return false
        },
        isPVE() {
            return this.$store.getters.getPublishingContractsDetailsContractType === 'PVE'
        },
    },
    methods: {
        territoryCode(entry) {
            if (entry && typeof entry === 'object') return entry.value || entry.text || ''
            return entry || ''
        },
        territoryLabel(entry) {
            const code = this.territoryCode(entry)
            const regionGroups = {
                WELT: { de: 'Welt', en: 'World' },
                DACH: { de: 'DACH', en: 'GAS' },
                EUR: { de: 'Europa', en: 'Europe' },
                MEA: { de: 'Naher Osten & Afrika', en: 'Middle East & Africa' },
            }
            if (regionGroups[code]) return regionGroups[code][this.$i18n.locale === 'de' ? 'de' : 'en']
            return this.$alvPlugin.getTranslatedCountryName(code, true) || String(code)
        },
        territoryOptionLabel(item) {
            if (item && typeof item === 'object') {
                const text = item.text || ''
                const value = item.value || ''
                if (text && value && text !== value) return text + ' (' + value + ')'
                return text || this.territoryLabel(value)
            }
            return this.territoryLabel(item)
        },
        toggleBulkTerritory(which) {
            const showKey = which === 'include' ? 'showBulkInclude' : 'showBulkExclude'
            const textKey = which === 'include' ? 'bulkIncludeText' : 'bulkExcludeText'
            if (this[showKey]) {
                this[textKey] = ''
                this[showKey] = false
                return
            }
            this[showKey] = true
        },
        territoryCodeList() {
            const available = this.$alvPlugin.getListOfTranslatedCountries() || []
            const codes = available.map(country => country.value)
            codes.push('WORLD')
            return codes
        },
        invalidTerritoryMessage(codes) {
            const list = codes.join(', ')
            if (this.$i18n.locale === 'de') return 'Ungültige Gebietscodes: ' + list
            return 'Invalid territory codes: ' + list
        },
        applyBulkTerritory(which) {
            const textKey = which === 'include' ? 'bulkIncludeText' : 'bulkExcludeText'
            const showKey = which === 'include' ? 'showBulkInclude' : 'showBulkExclude'
            const text = this[textKey]
            if (!text || text.trim() === '') return

            const parsed = parseBulkCountryString(text)
            const { valid, invalid } = splitTerritoryCodes(parsed, this.territoryCodeList())

            if (invalid.length > 0) {
                this.$store.commit('setSnackbar', {
                    type: valid.length > 0 ? 'warning' : 'error',
                    msg: this.invalidTerritoryMessage(invalid),
                })
            }

            if (valid.length === 0) return

            const getter = which === 'include'
                ? 'getPublishingContractsDetailsInclude'
                : 'getPublishingContractsDetailsExclude'
            const setter = which === 'include'
                ? 'setPublishingContractsDetailsInclude'
                : 'setPublishingContractsDetailsExclude'
            const current = this.$store.getters[getter] || []
            const currentCodes = current.map(entry => this.territoryCode(entry)).filter(Boolean)
            const merged = [...new Set([...currentCodes, ...valid])]
            this.$store.commit(setter, merged)
            this[textKey] = ''
            this[showKey] = false
        },
        removeTerritory(which, code) {
            const getter = which === 'include'
                ? 'getPublishingContractsDetailsInclude'
                : 'getPublishingContractsDetailsExclude'
            const setter = which === 'include'
                ? 'setPublishingContractsDetailsInclude'
                : 'setPublishingContractsDetailsExclude'
            const value = this.territoryCode(code)
            const list = this.$store.getters[getter] || []
            this.$store.commit(setter, list.filter((entry) => this.territoryCode(entry) !== value))
        },
        switchToSLG() {
            if (this.$store.getters.getPublishingContractsDetailsContractType === 'PVE') {
                this.$store.commit('setPublishingContractsDetailsArColl', null)
                this.$store.commit('setPublishingContractsDetailsMrColl', null)
                this.$store.commit('setPublishingContractsDetailsShareFrom', null)
                return
            }
            if (this.$store.getters.getPublishingContractsDetailsContractType == "SLG") {
                this.$store.commit('setPublishingContractsDetailsArColl', 50)
                this.$store.commit('setPublishingContractsDetailsMrColl', 100)
            } else {
                this.$store.commit('setPublishingContractsDetailsArColl', null)
                this.$store.commit('setPublishingContractsDetailsMrColl', null)
                this.$store.commit('setPublishingContractsDetailsShareFrom', null) 
            }
        },
    },
    created() {
        this.$store.commit('setCountries')
        this.$store.commit('setPublishingContractsTypes')
    },
    watch: {
        '$i18n.locale': {
            handler(newLocale, oldLocale) {
                const initialBalanceValue = this.$store.state.publishingContracts.publishingContractsDetails.initialBalance;

                if (initialBalanceValue) {
                    const formattedValue = newLocale === 'de' ?
                        initialBalanceValue.replaceAll('.', ',').replace(',', '.') :
                        initialBalanceValue.replaceAll(',', '.').replace('.', ',');

                    this.$store.commit('setPublishingContractsDetailsInitialBalance', formattedValue);
                }
            },
            immediate: true
    }
  }
}
</script>